export enum MapModeEnum {
  UTKAST_REGISTRATION = 'UTKAST_REGISTRATION',
  UTKAST_PRESENTATION = 'UTKAST_PRESENTATION',
  INVENTERING_REGISTRATION = 'INVENTERING_REGISTRATION',
  INVENTERING_PRESENTATION = 'INVENTERING_PRESENTATION',
  ACTIVE_LAYERS_ONLY = 'ACTIVE_LAYERS_ONLY',
  SEARCH = 'SEARCH',
  ADD_UTKAST_TO_INVENTERING = 'ADD_UTKAST_TO_INVENTERING',
  ADD_UTKAST_TO_ENKELINVENTERING = 'ADD_UTKAST_TO_ENKELINVENTERING',
  ADD_UTKAST_TO_SAMMANSATT = 'ADD_UTKAST_TO_SAMMANSATT',
  EDIT_GEOMETRY = 'EDIT_GEOMETRY',
  DEFAULT = 'DEFAULT',
  SAMMANSATT_UTKAST_PRESENTATION = 'SAMMANSATT_UTKAST_PRESENTATION'
}

export enum AktivitetStatusEnum {
  PLANERAD = 'PLANERAD',
  PAGAENDE = 'PAGAENDE',
  AVSLUTAD = 'AVSLUTAD'
}

export enum InteractionTypeEnum {
  NONE = 'NONE',
  DRAW = 'DRAW',
  DRAW_HOLE = 'DRAW_HOLE',
  MODIFY = 'MODIFY',
  TRANSFORM = 'TRANSFORM',
  MODIFY_DELETE = 'MODIFY_DELETE',
  SELECT = 'SELECT',
  UPLOAD_FILE = 'UPLOAD_FILE'
}

export enum AktivitetstypEnum {
  SKYDDSKLASSNING = 'SKYDDSKLASSNING',
  INVENTERING = 'INVENTERING',
  MIGRERING = 'MIGRERING',
  ENKELINVENTERING = 'ENKELINVENTERING',
  KULTURVARDE_FORSTORT = 'KULTURVARDE_FORSTORT',
  KVALITETSHOJNING = 'KVALITETSHOJNING'
}

export enum ActiveFeatureType {
  UTKAST_REDIGERBAR = 'UTKAST_REDIGERBAR',
  UTKAST_INSKICKAD = 'UTKAST_INSKICKAD',
  PUBLICERAD = 'PUBLICERAD',
  BYGGNADINDEX = 'BYGGNADINDEX',
  UNKNOWN = 'UNKNOWN',
  INVENTERING = 'INVENTERING',
  INVENTERING_PRELIMINAR = 'INVENTERING_PRELIMINAR',
  HAVT_SKYDD = 'HAVT_SKYDD'
}

export enum BebyggelseklassEnum {
  BYGGNAD = 'BYGGNAD',
  ANLAGGNING = 'ANLAGGNING',
  OMRADE = 'OMRADE',
  PLATS = 'PLATS',
  SAMMANSATT = 'SAMMANSATT'
}

export enum SkyddsklassningstypEnum {
  ANMALNINGSPLIKT_INFOR_BYGGNADSMINNE = 200,
  BESLUT_OM_BYGGNADSMINNE = 201,
  REVIDERING_AV_BYGGNADSMINNE = 202,
  HAVNING_AV_BYGGNADSMINNE = 203,
  HAVNING_AV_ANMALNINGSPLIKT = 204,
  REVIDERING_AV_ANMALNINGSPLIKT = 205,

  BESLUT_OM_STATLIGT_BYGGNADSMINNE = 300,
  REVIDERING_AV_STATLIGT_BYGGNADSMINNE = 301,
  HAVNING_AV_STATLIGT_BYGGNADSMINNE = 302,
  AGARBYTE_STATLIGT_BYGGNADSMINNE = 303,

  BESLUTAD_TILLSTANDSPLIKT_KYRKLIGT_KULTURMINNE = 401,
  AVGRANSNING_AV_KYRKOTOMT = 402,
  GENERELL_TILLSTANDSPLIKT_KYRKLIGT_KULTURMINNE = 403,
  VARDPLIKT_KYRKLIGT_KULTURMINNE = 404,
  FORSTORT_KYRKLIGT_KULTURMINNE = 405
}

export enum Layer {
  ORTOFOTO = 'ORTOFOTO',
  TOPOWEB = 'TOPOWEB',
  SKUGGNING = 'SKUGGNING',
  LUTNING = 'LUTNING',
  SJOKORT = 'SJOKORT',
  TOPOWEB_WMS = 'TOPOWEB_WMS',
  TOPOWEB_WMTS = 'TOPOWEB_WMTS',

  SELECTED_LM_BYGGNADSPOLYGON = 'SELECTED_LM_BYGGNADSPOLYGON',

  TEMPLATE_POLYGON = 'TEMPLATE_POLYGON',
  TEMPLATE_POINT = 'TEMPLATE_POINT',

  FASTIGHETSGRANSER_WMS = 'FASTIGHETSGRANSER_WMS',

  PUBLICERADE_BEBYGGELSEOBJEKT_YTOR_WMS = 'PUBLICERADE_BEBYGGELSEOBJEKT_YTOR_WMS',
  PUBLICERADE_BEBYGGELSEOBJEKT_SYMBOLER_WMS = 'PUBLICERADE_BEBYGGELSEOBJEKT_SYMBOLER_WMS',
  PUBLICERADE_BEBYGGELSEOBJEKT_SYMBOLER_WMTS = 'PUBLICERADE_BEBYGGELSEOBJEKT_SYMBOLER_WMTS',
  PUBLICERADE_BEBYGGELSEOBJEKT_YTOR_WMTS = 'PUBLICERADE_BEBYGGELSEOBJEKT_YTOR_WMTS',

  PUBLICERADE_AKTIVITETER_SYMBOLER_WMS = 'PUBLICERADE_AKTIVITETER_SYMBOLER_WMS',
  PUBLICERADE_AKTIVITETER_SYMBOLER_WMTS = 'PUBLICERADE_AKTIVITETER_SYMBOLER_WMTS',
  PUBLICERADE_AKTIVITETER_YTOR_WMTS = 'PUBLICERADE_AKTIVITETER_YTOR_WMTS',

  SOCKEN_WMS = 'SOCKEN_WMS',
  LANDSKAP_WMS = 'LANDSKAP_WMS',

  DRAW = 'DRAW',
  DRAW_DELETE = 'DRAW_DELETE',
  ACTIVE_SYMBOLER = 'ACTIVE_SYMBOLER',
  ACTIVE_YTA = 'ACTIVE_YTA'
}

export enum AuthorityRolesEnum {
  BEBYGGELSEREGISTRERARE = 'raa-bebyggelseregistrerare',
  BM_HANDLAGGARE = 'raa-bm-handlaggare',
  ORGANISATIONSBEHORIGHETSADMINISTRATOR = 'Organisationsbehörighetsadministratör',
  SAKOMRADESBEHORIGHETSADMINISTRATOR = 'Sakområdesbehörighetsadministratör',
  SBM_HANDLAGGARE = 'raa-sbm-handlaggare',
  GRANSKARE = 'raa-granskare'
}

export enum UserType {
  INTERN = 'INTERN',
  EXTERN = 'EXTERN',
  ANONYMOUS = 'ANONYMOUS'
}

export enum FotoVyEnum {
  EXTERIOR = 'EXTERIOR',
  INTERIOR = 'INTERIOR'
}

export enum RitningVyEnum {
  OVERSIKT = 'OVERSIKT'
}

export enum GenreFormStriktEnum {
  FOTOGRAFI = 'Fotografi',
  RITNING = 'Ritning'
}

export enum DokumentationstypEnum {
  BILD = 'BILD',
  RITNING = 'RITNING'
}

export enum LicensinformationEnum {
  COPYRIGHT_LANTMATERIET = 'COPYRIGHT_LANTMATERIET'
}

export enum RitningstypEnum {
  SITUATIONSPLAN = 'SITUATIONSPLAN',
  PLANRITNING = 'PLANRITNING'
}

export enum RegistreringsstatustypEnum {
  REDIGERBAR = 'REDIGERBAR',
  INSKICKAD = 'INSKICKAD',
  AVRAPPORTERAD = 'AVRAPPORTERAD'
}

export enum AktivitetRegistreringsstatustypEnum {
  REDIGERBAR = 'REDIGERBAR',
  INSKICKAD = 'INSKICKAD',
  AVRAPPORTERAD = 'AVRAPPORTERAD'
}

export enum VinjettSourceEnum {
  MELLANLAGRAD_RESURS = 'MELLANLAGRAD_RESURS',
  ARKIVERAD_RESURS = 'ARKIVERAD_RESURS'
}

export enum UpphovsmanTypEnum {
  UPPHOVSPERSON = 'UPPHOVSPERSON',
  UPPHOVSORGANISATION = 'UPPHOVSORGANISATION'
}

export enum HandelseTypEnum {
  BRAND = 'BRAND',
  FLYTTNING = 'FLYTTNING',
  NYBYGGNAD = 'NYBYGGNAD',
  OMBYGGNAD = 'OMBYGGNAD',
  RESTAURERING = 'RESTAURERING',
  RIVNING = 'RIVNING',
  TILLBYGGNAD = 'TILLBYGGNAD',
  TILLKOMST = 'TILLKOMST'
}

export enum SkyddstypEnum {
  ANMALNINGSPLIKT = 'ANMALNINGSPLIKT',
  BYGGNADSMINNE = 'BYGGNADSMINNE',
  STATLIGT_BYGGNADSMINNE = 'STATLIGT_BYGGNADSMINNE',
  KYRKLIGT_KULTURMINNE = 'KYRKLIGT_KULTURMINNE',
  IDENTIFIERAT_KULTURVARDE = 'IDENTIFIERAT_KULTURVARDE',
  FORSTORT_KULTURVARDE = 'FORSTORT_KULTURVARDE'
}

export enum BebyggelseobjektgruppEnum {
  ENSKILT_BEBYGGELSEOBJEKT = 'ENSKILT_BEBYGGELSEOBJEKT',
  OMRADE = 'OMRADE',
  SAMMANSATT = 'SAMMANSATT'
}

export const kkmSkyddsklassningstyper = [
  SkyddsklassningstypEnum.GENERELL_TILLSTANDSPLIKT_KYRKLIGT_KULTURMINNE,
  SkyddsklassningstypEnum.BESLUTAD_TILLSTANDSPLIKT_KYRKLIGT_KULTURMINNE,
  SkyddsklassningstypEnum.VARDPLIKT_KYRKLIGT_KULTURMINNE,
  SkyddsklassningstypEnum.AVGRANSNING_AV_KYRKOTOMT
];

export const sbmSkyddsklassningstyper = [
  SkyddsklassningstypEnum.BESLUT_OM_STATLIGT_BYGGNADSMINNE,
  SkyddsklassningstypEnum.REVIDERING_AV_STATLIGT_BYGGNADSMINNE,
  SkyddsklassningstypEnum.HAVNING_AV_STATLIGT_BYGGNADSMINNE,
  SkyddsklassningstypEnum.AGARBYTE_STATLIGT_BYGGNADSMINNE
];

export const bmSkyddsklassningstyper = [
  SkyddsklassningstypEnum.BESLUT_OM_BYGGNADSMINNE,
  SkyddsklassningstypEnum.REVIDERING_AV_BYGGNADSMINNE,
  SkyddsklassningstypEnum.HAVNING_AV_BYGGNADSMINNE,
  SkyddsklassningstypEnum.HAVNING_AV_ANMALNINGSPLIKT,
  SkyddsklassningstypEnum.ANMALNINGSPLIKT_INFOR_BYGGNADSMINNE
];
